export default "__VITE_ASSET__DJGlvp9d__"